export * from "./employment-contract-down";
import { EMPLOYMENT_FIELD_SIDES, EMPLOYMENT_FIELD_TYPES } from "../../constants";

/**
 * @typedef {object} EmploymentForm
 *
 * @property {string} _file
 * @property {null|File|object} [file]
 *
 * @property {string[]} _pages
 * @property {Array<null|File|object>} pages
 *
 * @property {string} _company
 *
 * @property {string} name
 * @property {EmploymentField[]} fields
 *
 * @property {string} createdAt
 * @property {string} updatedAt
 */

/**
 * @param {EmploymentForm} form
 * @returns {EmploymentForm}
 */
export function initEmploymentForm(form = {}) {
    return {
        ...(form || {}),

        _file: form?._file || null,
        file: form?.file || null,

        _pages: [...(form?._pages || [])],
        pages: [...(form?.pages || [])],

        _company: form?._company,

        name: form?.name || null,
        fields: [...(form?.fields || [])].map(initEmploymentField),

        createdAt: form?.createdAt,
        updatedAt: form?.updatedAt,
    };
}

/**
 * @typedef {object} EmploymentContract
 *
 *
 * @property {string[]} _pages
 * @property {Array<null|File|object>} pages
 *
 * @property {string} _form
 * @property {EmploymentForm} [form]
 *
 * @property {string} _person
 * @property {string} _company
 * @property {string} _application
 *
 * @property {string} subject
 * @property {boolean} isSigned
 * @property {EmploymentField[]} fields_document
 * @property {EmploymentField[]} fields_employee
 *
 * @property {string} createdAt
 * @property {string} updatedAt
 * @property {string} signedAt
 */

/**
 * @param {EmploymentContract} form
 * @returns {EmploymentContract}
 */
export function initEmploymentContract(form = {}) {
    return {
        ...(form || {}),

        _form: form?._form || null,
        form: form?.form,

        _person: form?._person || null,
        _company: form?._company || null,
        _application: form?._application || null,

        subject: form?.subject || null,
        isSigned: form?.isSigned ?? false,
        fields_document: [...(form?.fields_document || [])].map(initEmploymentField),
        fields_employee: [...(form?.fields_employee || [])].map(initEmploymentField),

        createdAt: form?.createdAt,
        updatedAt: form?.updatedAt,
        signedAt: form?.signedAt,
    };
}

/**
 * @typedef {object} EmploymentField
 *
 * @property {string} _img
 * @property {null|File|object} img
 *
 * @property {string} _file
 * @property {null|File|object} file
 *
 * @property {keyof EMPLOYMENT_FIELD_SIDES} side
 * @property {keyof EMPLOYMENT_FIELD_TYPES} type
 *
 * @property {string} term
 * @property {string|boolean} data
 *
 * @property {number} page
 *
 * @property {object} axis
 * @property {number} axis.x
 * @property {number} axis.y
 *
 * @property {object} size
 * @property {number} size.w
 * @property {number} size.h
 *
 * @property {boolean} isRequired
 *
 * @property {string} [tempId]
 */

/**
 * @param {EmploymentField} form
 * @returns {EmploymentField}
 */
export function initEmploymentField(form = {}) {
    return {
        ...(form || {}),

        _img: form?._img || null,
        img: form?.img || null,

        _file: form?._file || null,
        file: form?.file || null,

        side: form?.side || EMPLOYMENT_FIELD_SIDES.DOCUMENT.value,
        type: form?.type || EMPLOYMENT_FIELD_TYPES.TEXT.value,

        term: form?.term || null,
        data: form?.data || null,

        page: form?.page ?? 0,

        axis: {
            ...(form?.axis || {}),
            x: form?.axis?.x || 0,
            y: form?.axis?.y || 0,
        },

        size: {
            ...(form?.size || {}),
            w: form?.size?.w || 0,
            h: form?.size?.h || 0,
        },

        isRequired: form?.isRequired || false,

        tempId: form?.tempId ?? `${Math.random()}`.slice(2),
    };
}
